import React from 'react';
import { X, Plus, Minus, ShoppingBag, ArrowRight, Trash2 } from 'lucide-react';
import { useCart } from '../context/CartContext';
import { useNavigate } from 'react-router-dom';
import { resolveUrl } from '../lib/api';

export default function CartDrawer() {
  const { items, open, setOpen, remove, setQty, subtotal, gst, pst, total, count } = useCart();
  const nav = useNavigate();

  return (
    <>
      {open && <div className="fixed inset-0 bg-black/50 z-[80]" onClick={() => setOpen(false)} />}
      <aside className={`fixed right-0 top-0 h-full w-full sm:w-[420px] bg-white z-[90] shadow-2xl flex flex-col transform transition-transform ${open ? 'translate-x-0' : 'translate-x-full'}`}>
        <div className="flex items-center justify-between px-6 py-4 border-b border-gray-100">
          <div className="flex items-center gap-3">
            <ShoppingBag className="text-[#ED2E2E]" size={22} />
            <h3 className="font-heading font-bold text-lg text-[#0F1C2E]">Your Cart ({count})</h3>
          </div>
          <button onClick={() => setOpen(false)} className="p-2 hover:bg-gray-100 rounded-full"><X size={20} /></button>
        </div>

        <div className="flex-1 overflow-y-auto px-6 py-4">
          {items.length === 0 ? (
            <div className="h-full flex flex-col items-center justify-center text-center text-gray-400">
              <ShoppingBag size={48} className="mb-4 opacity-40" />
              <p className="mb-4">Your cart is empty</p>
              <button onClick={() => { setOpen(false); nav('/menu'); }} className="btn-wrappus text-sm">Browse Menu <ArrowRight size={14} /></button>
            </div>
          ) : (
            <div className="space-y-4">
              {items.map((i) => (
                <div key={i.id} className="flex gap-3 pb-4 border-b border-gray-100">
                  {i.image ? <img src={resolveUrl(i.image)} alt={i.name} className="w-16 h-16 rounded-xl object-cover" /> : <div className="w-16 h-16 rounded-xl bg-[#FDF3EC]" />}
                  <div className="flex-1 min-w-0">
                    <div className="font-semibold text-[#0F1C2E] text-sm">{i.name}</div>
                    <div className="text-[#ED2E2E] font-bold text-sm mt-0.5">${i.price.toFixed(2)}</div>
                    <div className="flex items-center gap-3 mt-2">
                      <div className="flex items-center border border-gray-200 rounded-full">
                        <button onClick={() => setQty(i.id, i.qty - 1)} className="p-1.5 hover:text-[#ED2E2E]"><Minus size={12} /></button>
                        <span className="px-2 text-sm font-semibold">{i.qty}</span>
                        <button onClick={() => setQty(i.id, i.qty + 1)} className="p-1.5 hover:text-[#ED2E2E]"><Plus size={12} /></button>
                      </div>
                      <button onClick={() => remove(i.id)} className="text-gray-400 hover:text-[#ED2E2E]"><Trash2 size={14} /></button>
                    </div>
                  </div>
                </div>
              ))}
            </div>
          )}
        </div>

        {items.length > 0 && (
          <div className="border-t border-gray-100 p-6 bg-[#FDF3EC]">
            <div className="space-y-1 text-sm mb-4">
              <div className="flex justify-between"><span className="text-gray-600">Subtotal</span><span className="font-semibold">${subtotal.toFixed(2)}</span></div>
              <div className="flex justify-between"><span className="text-gray-600">GST (5%)</span><span className="font-semibold">${gst.toFixed(2)}</span></div>
              {pst > 0 && (
                <div className="flex justify-between"><span className="text-gray-600">PST (7%)</span><span className="font-semibold">${pst.toFixed(2)}</span></div>
              )}
              <div className="flex justify-between text-base pt-2 border-t border-gray-200 mt-2"><span className="font-bold text-[#0F1C2E]">Total</span><span className="font-bold text-[#ED2E2E]">${total.toFixed(2)}</span></div>
            </div>
            <button onClick={() => { setOpen(false); nav('/checkout'); }} className="btn-wrappus w-full justify-center">
              Checkout <ArrowRight size={16} />
            </button>
          </div>
        )}
      </aside>
    </>
  );
}
